import { createSlice } from '@reduxjs/toolkit';
import { LanguageModel } from 'Models/LanguageModel';
import { LocationModel } from 'Models/LocationModel';

export interface CAMPAIGN_HISTORY_ITEM {
  project_id: number,
  campaign_id: number,
  campaign_name: string
}
export interface CAMPAIGN_ENQUIRY_HISTORY_ITEM {
  campaign_id: number,
  tab_label: string,
  tab_value: string,
}
export interface AppDataState {
  languages: LanguageModel[],
  locations: LocationModel[],
  campaignHistory: CAMPAIGN_HISTORY_ITEM[],
  campaignEnquiryHistory: CAMPAIGN_ENQUIRY_HISTORY_ITEM[]
}

const initialState: AppDataState = {
  languages: [],
  locations: [],
  campaignHistory: [],
  campaignEnquiryHistory: []
}
export const slice = createSlice({
  name: 'appdata',
  initialState,
  reducers: {
    testAction: (state, action) => {
      state = initialState
    },
    loadSiteAction: (state, action) => {

    },
    loadLanguagesAction: (state, action) => {
      state.languages = action.payload
    },
    loadLocationsAction: (state, action) => {
      state.locations = action.payload
    },
    addCampaignHistory: (state, action) => {
      const oldHistory = (state.campaignHistory || []).filter(c => c.campaign_id != action.payload.campaign_id)
      state.campaignHistory = [
        action.payload,
        ...oldHistory,
      ].slice(0, 100)
    },
    addCampaignEnquiryHistory: (state, action) => {
      const oldHistory = (state.campaignEnquiryHistory || []).filter(c => c.tab_value != action.payload.tab_value)
      state.campaignEnquiryHistory = [
        ...oldHistory,
        action.payload
      ]
    },
  },
});

export const {
  testAction,
  loadSiteAction,
  loadLanguagesAction,
  loadLocationsAction,
  addCampaignHistory,
  addCampaignEnquiryHistory
} = slice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
// export const incrementAsync = amount => dispatch => {
//   setTimeout(() => {
//     dispatch(incrementByAmount(amount));
//   }, 1000);
// };

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`

export default slice.reducer;

